import React from 'react';
import {
    Tableau,
    TableauHeader,
    TableauBody,
    TableauRow,
    TableauHeaderCell,
    TableauCell,
    Carte,
    CarteBody,
    CarteContent,
    CarteDescription,
    Col,
    Row,
    Container,
    CarteFooter,
} from '@design-system-etat/dsfr-react';
import { nanoid } from 'nanoid';
import * as PropTypes from 'prop-types';
import AffichageResponsive from '../AffichageResponsive';
import './SimpleTable.scss';

const SimpleTable = ({ entete, donnees, isLoading, boutonActionsPresent }) => {
    const creerCarteResultat = (resultat) => {
        const contenuCarte = entete.map((column, index) => {
            return { header: column, valeur: resultat[index] };
        });
        return (
            <Col col={12} className="padding-carte" key={nanoid(23)}>
                <Carte noEnlargeLink>
                    <CarteBody>
                        <CarteContent>
                            <CarteDescription>
                                {contenuCarte
                                    /* On enleve la dernière colonne qui contient les boutons d'action */
                                    .slice(...(boutonActionsPresent ? [0, -1] : []))
                                    .map((column) => (
                                        <p key={nanoid(10)}>
                                            <b>{column.header} : </b>
                                            {column.valeur}
                                        </p>
                                    ))}
                            </CarteDescription>
                        </CarteContent>
                    </CarteBody>
                    {boutonActionsPresent && (
                        <CarteFooter>
                            <Container>
                                <Row gouttiere className="boutons-action">
                                    {/* Les boutons d'action sont toujours dans la dernière colonne */}
                                    <Col key={`action-column-${nanoid(10)}`}>
                                        {resultat.slice(-1)}
                                    </Col>
                                </Row>
                            </Container>
                        </CarteFooter>
                    )}
                </Carte>
            </Col>
        );
    };

    return (
        <AffichageResponsive
            composantDesktop={
                <Tableau isLoading={isLoading}>
                    <TableauHeader>
                        <TableauRow>
                            {entete.map((title) => (
                                <TableauHeaderCell scope="col" key={title}>
                                    {title}
                                </TableauHeaderCell>
                            ))}
                        </TableauRow>
                    </TableauHeader>
                    <TableauBody>
                        {donnees.map((row) => {
                            return (
                                <TableauRow key={nanoid(10)}>
                                    {row.map((cell) => {
                                        return <TableauCell key={nanoid(10)}>{cell}</TableauCell>;
                                    })}
                                </TableauRow>
                            );
                        })}
                    </TableauBody>
                </Tableau>
            }
            composantMobile={
                <>
                    <Row gouttiere className="marge-resultats-mobile">
                        {donnees.map((resultat) => creerCarteResultat(resultat))}
                    </Row>
                </>
            }
            pointDeRupture="lg"
        />
    );
};

SimpleTable.propTypes = {
    entete: PropTypes.array,
    donnees: PropTypes.array,
    isLoading: PropTypes.bool,
    boutonActionsPresent: PropTypes.bool,
};

SimpleTable.defaultProps = {
    entete: [],
    donnees: [],
    isLoading: false,
    boutonActionsPresent: false,
};

export default SimpleTable;
